import type { AuthorListView } from "@newgenerated/shared/schema";

export function formatAuthorName(author: AuthorListView, singleLetterMiddleName: boolean = false): string {
  const names = [];
  if (author.firstName !== null && author.firstName.trim() !== "") {
    names.push(author.firstName.trim());
  }
  if (author.middleName !== null && author.middleName.trim() !== "") {
    names.push(singleLetterMiddleName ? `${author.middleName[0]}.` : author.middleName);
  }
  if (author.lastName !== null && author.lastName.trim() !== "") {
    names.push(author.lastName.trim());
  }
  return names.join(" ");
}
